/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:01:49 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import uploadFile from './UPLOAD_FILE';
import moment from 'moment';

export const CreateAdvertMutation = gql`
  mutation createAdvert(
    $name: String!
    $advertiserName: String!
    $url: URL!
    $imageId: ID!
    $startDate: Date!
    $endDate: Date!
    $duration: Int!
    $frequencyWeight: Int
    $status: AdvertStatus
    $regions: [ID!]!
  ) {
    data: createAdvert(
      name: $name
      advertiserName: $advertiserName
      url: $url
      imageId: $imageId
      startDate: $startDate
      endDate: $endDate
      duration: $duration
      frequencyWeight: $frequencyWeight
      status: $status
      regions: $regions
    ) {
      id
      name
      advertiserName
      url
      image {
        id
        url
      }
      startDate
      endDate
      duration
      frequencyWeight
      status
      statistics {
        engagements
        impressions
      }
      regions {
        id
        name
      }
    }
  }
`;

export default async ({ client, params }) => {
  try {
    if (params.data.adImage && params.data.adImage.hasOwnProperty('rawFile')) {
      const responseFile = await uploadFile({
        client,
        file: params.data.adImage,
      });
      params.data.imageId = responseFile.id;
    }
    if (params.data.startDate) {
      params.data.startDate = moment(params.data.startDate).format(
        'YYYY-MM-DD'
      );
    }
    if (params.data.endDate) {
      params.data.endDate = moment(params.data.endDate).format('YYYY-MM-DD');
    }
    return client.mutate({
      mutation: CreateAdvertMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
